import axios from 'axios'
import config from './config'
import apiList from './api'
import repeatWhiteList from './repeatWhiteList'
import { Message } from 'element-ui'
import { getDevice } from '@/utils'
import Store from '@/store'

// axios 全局配置
axios.defaults.timeout = config.timeout;

//防止post重复呼叫
let postCount = {};
/**
 * @method api 统一请求方式
 * @param {String} url 请求的url 
 * @param {Object} data 请求体
 * @param {String} method 请求类型
 * @param {Object} headers 请求头
 * @param {Boolean} exceptionsTip 是否自动处理返回非1000的请求
 */
const api = (url, data, method = 'post', headers = {}, exceptionsTip = true, loading = true) => {
    // 填充默认参数
    if (headers['Content-Type'] !== 'multipart/form-data') data = { ...config.default,...data }
    // 从接口字典中获取完整接口
    let _url,
        _api,
        url_split = url.split('/')
    if (url_split.length > 1) _url = apiList[url_split[0]][url_split[1]]
    else _url = apiList[url]
    _api = _url
    _url = `${config.baseUrl}${_url}`
    let httpOpts = {
        url: _url,
        method: method,
        headers: {
            ...headers
        }
    };

    //post跟get的参数判断
    if (typeof method === 'string') {
        if (method === "post") {
            httpOpts.data = data;
        } else if (method === "get") {
            httpOpts.params = data;
        } else if (method === "delete") {
            httpOpts.params = data;
        } else if (method === "put") {
            httpOpts.data = data;
        }
    }

    if (!httpOpts.headers["Content-Type"]) httpOpts.headers = { "Content-Type": "application/json" };       
    let promise = new Promise(async (resolve, reject) => {
        // 若api存在于重复请求白名单则取消重复请求校验 
        if (postCount[_url] && !repeatWhiteList[_api]) return alert(config.errorMsg.repeat)
        else {
            let res;
            postCount[_url] = "posting";
            if(loading) Store.commit("SET_LOADING", true)
            try {
                res = await axios({ ...httpOpts })
            } catch (e) {
                alert(config.errorMsg.link_failure);
            }
            if (res) {
                let _data = res.data
                if (exceptionsTip && _data && _data.returnCode != 1000) {
                    Message({ customClass: getDevice(), showClose: true, message: _data.message || '請求錯誤，請聯繫管理員', type: 'error' })
                }
                resolve(_data)
            }
            if(loading) Store.commit("SET_LOADING", false)
            delete postCount[_url];
        }
    });

    return promise;
};

export default api
